export const environment = {
  production: true,
  test: false,
  websockeEndpoint: 'wss://ws.advisor.co2online.de',
  stylePath: []
};
